export const transferForm = {
	loadingTargetPlaceData: "Loading data from target place...",
	reviewLabels: {
		balanceAfterTransferAtSourcePlace: "Balance after transfer at source place",
		balanceAfterTransferAtTargetPlace: "Balance after transfer at target place",
	},
	submitFailedMessage: "Failed to transfer value",
	submitSucceededMessage: "Value transferred successfully",
	transferTotalValueBtn: "Transfer all balance available",
	balanceAvailable: "Balance available",
	enoughBalanceMessage: "Balance available for transfer",
	selectPlaceLabel: "Select target place",
	selectPlacePlaceholder: "Select place to receive transfer",
	wizardLabels: {
		target: "Target",
		value: "Value to transfer",
		review: "Review data",
	},
};
